import { render } from "./foroshghahi.vue?vue&type=template&id=2c9796dd"
import script from "./foroshghahi.vue?vue&type=script&lang=js"
export * from "./foroshghahi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/bime-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__